import { createContext, useContext } from 'react';

export interface AccountContext {
  createdAt: string;
  externalId: string;
  planName: string;
}

const accountContext = createContext<AccountContext | undefined>(undefined);

export const AccountContextProvider = accountContext.Provider;

export const useAccountContext = () => {
  return useContext(accountContext);
};
